import type { TFunction } from 'i18next';
import type { AnalyticsPlatform } from 'api/new-analytics/types';
import type { ReportPreviewProfile } from 'api/analytics-reports/types';
import { analyticsPlatformToPageType } from 'app/modules/analytics/modules/content/utils/analyticsPlatformToPageType';
import type { ProfileCardPreviewMeta } from 'app/modules/analytics/modules/reports/utils/resolveProfileCardPreviewMeta';

const SUPPORTED_PLATFORMS: AnalyticsPlatform[] = [
  'facebook',
  'instagram',
  'linkedin',
  'tiktok',
];

function isAnalyticsPlatform(value: string): value is AnalyticsPlatform {
  return SUPPORTED_PLATFORMS.includes(value as AnalyticsPlatform);
}

export function resolveReportPreviewProfileHeaderMeta(
  profile: ReportPreviewProfile,
  t: TFunction,
): ProfileCardPreviewMeta {
  if (profile.type === 'general') {
    return {
      label: t('analyticsReports.viewModal.generalProfile'),
    };
  }

  const placeholder = t('analyticsReports.createReport.profileCardPlaceholder');
  const label = profile.page_name?.trim() || placeholder;
  const logoSrc = profile.page_image_url ?? undefined;
  const pageType =
    profile.platform && isAnalyticsPlatform(profile.platform)
      ? analyticsPlatformToPageType(profile.platform)
      : undefined;

  return {
    label,
    logoSrc,
    pageType,
  };
}
